export const MOS_PACKAGE = 'es.maximiliana.maximiliana';
